// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[data-v-934e529c]:invalid{background-color:#ffe5ed}
`, "",{"version":3,"sources":["webpack://./vue-components/editable-text.vue"],"names":[],"mappings":"AACA,+BACC,wBAAA","sourcesContent":["\ninput:invalid {\n\tbackground-color: #ffe5ed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
